    const initialState = {
    data: [],
    isLoading: false,
    error: null,
    currentPage: 0,
  };
  
  import { collection, composeReducers } from "common/store/reducer";
  
  import { NAMESPACE } from "./actions";

  import { DETACH_SUCCESS_FROM_TAGS_HISTORY } from "./actions";
  
  const initial = {
    ...collection.defaultSort("id"),
  };

  const detachSuccessFromTagsHistory = (state, {uniqueId}) => {
    const now = new Date();
    const isoString = now.toISOString();
    return{
      ...state,
      data: state.data.map(obj=>{
        if(obj.uniqueId === uniqueId){
          return {...obj,  detached:isoString};
        }
        return obj;
      })
    };
  }
  
  const collectionReducer = (state = initialState, action) => {
    const reducer = {
      [DETACH_SUCCESS_FROM_TAGS_HISTORY]: detachSuccessFromTagsHistory
    }[action.type];
  
    return reducer ? reducer(state, action) : state;
  };
  
  export default composeReducers(
    collection.factory(NAMESPACE),
    collectionReducer,
    (state = initialState) => state
  );
  